import { motion } from "framer-motion";
import styles from "./About.module.css";

const About = () => {
  return (
    <motion.div
      className={styles.container}
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
    >
      <h2 className={styles.title}>Who We Are</h2>

      <motion.div className={styles.content} initial="hidden" animate="visible" variants={{
        visible: { transition: { staggerChildren: 0.2 } }
      }}>
        <motion.p className={styles.paragraph} variants={fadeUp}>
        MyApple is a consulting and web development agency specializing in logistics optimization, data analysis and smart tools for transport & retail businesses.
        </motion.p>

        <motion.p className={styles.paragraph} variants={fadeUp}>
          With over 10 years of hands-on experience in Warehouse Management Systems (WMS), .NET development, and database design, we ’ve developed custom integrations and automation solutions for major Greek companies in retail, tourism and logistics.
        </motion.p>

        <motion.p className={styles.paragraph} variants={fadeUp}>
          We specialize in reducing operational inefficiencies in logistics and transportation, using tools like SQL, Python, Power BI, and custom-built systems to create solutions tailored to each business.
        </motion.p>
        <motion.p className={styles.paragraph} variants={fadeUp}>
          In addition to logistics and data consulting, we have a strong background in full-stack web development. We design and build modern web applications that enhance business processes — from internal dashboards to public-facing systems. Our focus is always on performance, usability, and solving real business problems with clean, scalable code.
        </motion.p>
        <motion.p className={styles.paragraph} variants={fadeUp}>
          We primarily use React, Node.js, Express, PostgreSQL, and Bootstrap or Tailwind CSS for styling, and we enjoy integrating modern libraries like Framer Motion and Chart.js to create dynamic UIs.
        </motion.p>


        <motion.p className={styles.paragraph} variants={fadeUp}>
          Our goal is simple: <strong>maximize profit and minimize costs</strong> for the businesses we support — through technology, data, and deep logistics understanding.
        </motion.p>

              <motion.div
        className={styles.ctaBox}
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.8, duration: 0.6 }}
      >
        <h3>Ready to optimize your business?</h3>
        <p>
          Let’s talk about how we can improve your logistics operations, reduce costs,
          and increase profits with smart solutions.
        </p>
        <a href="/contact" className={styles.ctaButton}>
          Contact Me →
        </a>
      </motion.div>

      </motion.div>
    </motion.div>
  );
};

const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0 }
};

export default About;
